import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.5 1.5h-2.25V.75a.75.75 0 0 0-1.5 0v.75h-7.5V.75a.75.75 0 0 0-1.5 0v.75H1.5A1.5 1.5 0 0 0 0 3v15a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 18 18V3a1.5 1.5 0 0 0-1.5-1.5M3.75 3v.75a.75.75 0 0 0 1.5 0V3h7.5v.75a.75.75 0 0 0 1.5 0V3h2.25v3h-15V3zM1.5 18h15V7.5h-15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }